import { usePagination } from "../../../providers/PaginationProvider/PaginationProvider";

import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";

import { PayoutsTable } from "../PayoutsTable";
import { BackButton } from "../../BackButton";
import { Pagination } from "../../Pagination";

export default function ViewAllPayoutsWrapper({
  bankAccount,
  payouts,
  handleView,
}) {
  const {
    currentPage,
    setCurrentPage,
    perPage,
    pageCount,
    setPageCount,
    resultsPerPageOpts,
    handleChange,
  } = usePagination();

  return (
    <>
      <Card body>
        <Stack
          direction="horizontal"
          gap={3}
          className="card-body-heading card-body-heading--sm"
        >
          <BackButton size="sm" />
          <Stack direction="horizontal" gap={3} className="payouts">
            <Card.Title as="h5">Payouts</Card.Title>
          </Stack>
        </Stack>
        <PayoutsTable
          payouts={payouts}
          bankAccount={bankAccount}
          handleView={handleView}
          colSpan="7"
        />
      </Card>
      <Pagination
        pageCount={pageCount}
        perPage={perPage}
        currentPage={currentPage}
        resultsPerPageOpts={resultsPerPageOpts}
        handleClick={(value) => setCurrentPage(value.selected)}
        handleChange={handleChange}
      />
    </>
  );
}
